var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPmsApplication(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-PMS_Application"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PMS_Application",
    "data-name": "PMS Application",
    clipPath: "url(#clip-PMS_Application)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "booking",
    transform: "translate(0 -12.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M79.436,15.5H20.564a20.564,20.564,0,0,0-.123,41.128h9.236V40.516A13.1,13.1,0,0,1,42.763,27.43h.029A13.106,13.106,0,0,1,55.85,40.516V56.628H79.436a20.564,20.564,0,0,0,0-41.128Zm5.819,17.7L73.537,44.915a2.929,2.929,0,0,1-4.143,0l-5.859-5.859a2.93,2.93,0,1,1,4.143-4.143L71.465,38.7l9.647-9.647A2.93,2.93,0,1,1,85.255,33.2Z",
    transform: "translate(0 0)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M138.612,138.165l-18.86-1.96v-22.4a7.227,7.227,0,1,0-14.453,0v37.484h-.066L98.1,145.335a6.951,6.951,0,1,0-8.908,10.672l14.479,12.082h42.644v-21.2a8.789,8.789,0,0,0-7.7-8.721Z",
    transform: "translate(-69.761 -73.292)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M181.95,457.359a2.93,2.93,0,0,0,2.93,2.93h35.156a2.93,2.93,0,0,0,2.93-2.93V451.5H181.95Z",
    transform: "translate(-146.413 -350.844)",
    fill: "#e8eaf0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPmsApplication);
export default __webpack_public_path__ + "static/media/pms-application.856c1897018caedd0df9712b0bc64ac6.svg";
export { ForwardRef as ReactComponent };